import {
  Box, Button,
} from '@mui/material';
import { useMemo, useState } from 'react';
import ImageSelectionModal from './ImageSelectionModal';
import { ImageItem } from '../../../contexts/ImagesContext';

interface ImageModalProps {
  title?: string
  children?: JSX.Element
  disabled?: boolean
  absoluteButton?: boolean
  handleOnConfirm: (url: string) => void
  showModalFromOutside?: boolean
  onCloseModalFromOutside?: () => void
  showTitle?: boolean
}

const ImageModal = (props: ImageModalProps) => {
  const {
    title, children, disabled, absoluteButton = true, handleOnConfirm, onCloseModalFromOutside, showModalFromOutside, showTitle = true,
  } = props;

  const [localShowModal, setLocalShowModal] = useState(false);
  const modalShow = typeof showModalFromOutside === 'boolean' ? showModalFromOutside : localShowModal;
  const setModalShow = setLocalShowModal;

  const handleSave = (item: ImageItem) => {
    if (item) {
      handleOnConfirm(item.url);
    }
    setModalShow(false);
    if (onCloseModalFromOutside) {
      onCloseModalFromOutside();
    }
  };

  const buttonStyle = useMemo(() => {
    if (absoluteButton) {
      return {
        position: 'absolute',
        backgroundColor: '#5555558A',
        top: 10,
        left: 10,
        zIndex: 1,
      };
    }
    return {
      backgroundColor: '#5555558A',
    };
  }, [absoluteButton]);

  return (
    <>
      {children ? (
        <Box
          sx={{
            height: '100%',
            maxHeight: '100%',
            width: '100%',
            maxWidth: '100%',
          }}
          onClick={(event) => {
            if (disabled) return;
            setModalShow(true);
            event.stopPropagation();
          }}
        >
          {children}
        </Box>
      ) : (
        showTitle && (
        <Button
          onClick={(event) => {
            setModalShow(true);
            event.stopPropagation();
          }}
          variant="contained"
          component="label"
          sx={buttonStyle}
        >
          {title || 'Select image'}
        </Button>
        )
      )}
      <ImageSelectionModal
        open={modalShow}
        handleClose={() => {
          setModalShow(false);
          if (onCloseModalFromOutside) {
            onCloseModalFromOutside();
          }
        }}
        handleSave={(item) => {
          handleSave(item);
        }}
      />
    </>
  );
};

export default ImageModal;
